import { GLASS_SURFACES, CARD_SOLID_SURFACE_CLASS } from '../config/glassSurfaces';

const SHIMMER = 'skeleton-shimmer';

/** Lightweight pulse placeholders matching the large event card layout (image left + text). */
export function EventListSkeleton({ count = 6 }) {
  return (
    <div className="space-y-4" aria-hidden>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`event-card-surface overflow-hidden rounded-[18px] animate-pulse ${
            GLASS_SURFACES.cards ? '' : CARD_SOLID_SURFACE_CLASS
          }`}
        >
          <div className="px-3 pt-3">
            <div className={`h-5 w-3/4 max-w-md rounded ${SHIMMER}`} />
          </div>
          <div className="flex flex-row items-start gap-3 p-3 pt-2">
            <div className={`w-24 h-24 rounded-lg flex-shrink-0 ${SHIMMER}`} />
            <div className="flex-1 min-w-0 space-y-2 pt-0.5">
              <div className={`h-3.5 w-full rounded ${SHIMMER}`} />
              <div className={`h-3.5 w-4/5 rounded ${SHIMMER}`} />
              <div className={`h-3 w-1/3 rounded ${SHIMMER}`} />
              <div className="flex gap-1.5 mt-2">
                <div className={`h-8 w-16 rounded-lg ${SHIMMER}`} />
                <div className={`h-8 w-8 rounded-lg ${SHIMMER}`} />
                <div className={`h-8 w-8 rounded-lg ${SHIMMER}`} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

/** Single hero-style placeholder for the horizontal Trending rail (full-bleed scroller; header lives in parent). */
export function TrendingRailSkeleton() {
  return (
    <div
      className="trending-rail-scroll overflow-x-auto snap-x snap-mandatory flex gap-3 pb-2 scrollbar-hide pl-4 pr-4 sm:pl-6 sm:pr-6 scroll-pl-4 sm:scroll-pl-6"
      aria-hidden
    >
      <div className="snap-start [@media(hover:hover)]:snap-center shrink-0 w-[85%] max-w-[640px] [@media(hover:hover)]:max-w-[800px]">
        <div
          className={`relative w-full rounded-2xl overflow-hidden animate-pulse h-64 ${
            GLASS_SURFACES.cards ? 'event-card-surface' : CARD_SOLID_SURFACE_CLASS
          }`}
        >
          <div className="absolute inset-x-0 bottom-0 p-4 space-y-2">
            <div className={`h-6 w-3/4 max-w-md rounded ${SHIMMER}`} />
            <div className={`h-4 w-1/2 max-w-xs rounded ${SHIMMER}`} />
            <div className={`mt-2 h-12 w-28 rounded-btn ${SHIMMER}`} />
          </div>
        </div>
      </div>
    </div>
  );
}
